<template>
  <img class="face-log-photo"
    :src="srcUrl"
    :key="faceLogId"
    loading="lazy"
    @load="onLoad"
    @error="onError"
  />
</template>
<script>
export default {
  name: 'FaceLogPhoto',
  props: {
    faceLogId: Number,
    // The photo's signed Cloud CDN URL from the API (faceLogPhotoUrl). Null when the face log was
    // purged, or the CDN isn't set up.
    photoUrl: String
  },
  data () {
    return {
      // A photo URL that failed to load: its photo was moved when an identity was attached to an
      // unidentified face log, or deleted, or its signature expired on a page left open.
      failedPhotoUrl: null
    }
  },
  computed: {
    srcUrl () {
      return (this.faceLogId && this.photoUrl !== this.failedPhotoUrl && this.photoUrl) || '/img/stock-face.png'
    }
  },
  methods: {
    onLoad () {
      this.$emit('load')
    },
    onError () {
      if (this.srcUrl === this.photoUrl) {
        this.failedPhotoUrl = this.photoUrl
      }
    }
  }
}
</script>
<style scoped>
.face-log-photo {
  max-width: 120px;
  max-height: 160px;
  border: 1px solid #ccc;
  border-radius: 6px;
}
</style>
